/********************************************************************************
 * Copyright (c) 2026 CrossBreeze, EclipseSource and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the MIT License which is available in the project root.
 *
 * SPDX-License-Identifier: MIT
 ********************************************************************************/

// Generic JSON-RPC primitives shared across the framework's typed
// protocol heads — see `data/data-protocol-methods.ts` for the
// specialised composition.

export * from './bind-rpc-methods';
export * from './create-rpc-proxy';
export * from './send-by-method-name';
export * from './wire-prefix';
